module.exports = __webpack_public_path__ + "assets/img/rozwiazania-dla-inwestorow.a8fa6e63.jpg";